import React, { Component } from 'react';
import { Row, Col } from 'antd';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';
import TextSection from '../BaseComponents/TextSection';
import TextSectionWithStructuredBullets from '../BaseComponents/TextSectionWithStructuredBullets';
import ImageBulletedSection from '../BaseComponents/ImageBulletedSection';

class DigitalTransformationContent extends Component {
  render() {
    
    const lang = StoreManager.appState.thisApp.state.currentLanguage;
    const content = languages[lang].DigitalTransformationContent;


    const formatQuote = (text) => {
      const match = text.match(/“([^”]+)”(.*)/);
      if (!match) return { boldPart: text, normalPart: '' };
      return {
        boldPart: `“${match[1]}”`,
        normalPart: match[2]
      };
    };

    const { boldPart, normalPart } = formatQuote(content.section5Message);
    const {isMobile} = StoreManager.appState.thisApp.state


    return (
      <div>
         <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 500, lineHeight: 1.2 }}>
          {content.title}
        </h2>
        <TextSection title={content.section1Title} paragraphs={content.section1TextArray} />
        <TextSection title={content.section2Title} paragraphs={content.section2TextArray} />
        <TextSectionWithStructuredBullets  title={content.section3Title} paragraphs={content.section3TextArray}/>
        <h2 style={{ fontSize: 24, fontWeight: 600, marginBottom: 5 }}>
          {content.section4Title}
        </h2>
        {
          content.section4TextArray1.map((item, i) => (
            <TextSection
              key={`section4-${i}`}
              title={item.title}
              paragraphs={[item.text]} // phải là mảng vì TextSection nhận mảng `paragraphs`
              titleFontSize={16}
            />
          ))
        }

        <ImageBulletedSection items={content.section4TextArray2} />

        <TextSection title={content.section5Title} paragraphs={content.section5TextArray1} />
        <div style={{padding: 10, paddingLeft: 20, paddingRight: 20, backgroundColor: '#EDF8FF', borderRadius: 10}}>
          <div style={{ fontSize: 16, color: '#212121', lineHeight: '24px' }}>
            <p style={{fontWeight: 500}}>{`${boldPart}${normalPart}`}</p>
          </div>
        </div>
        

        <ImageBulletedSection items={content.section5TextArray2} />

        <TextSection title={content.section6Title} paragraphs={content.section6TextArray} />

        <ImageBulletedSection items={content.section6ImageBulletedSection} />

        <TextSection title={content.section6SubTitle} paragraphs={content.section6SubArray} />




        
      </div>
    );
  }
}

export default DigitalTransformationContent;
